import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentDialogSuggestionAgentWireframe from './VeltCommentDialogSuggestionAgentWireframe/VeltCommentDialogSuggestionAgentWireframe';
import VeltCommentDialogSuggestionAuthorWireframe from './VeltCommentDialogSuggestionAuthorWireframe/VeltCommentDialogSuggestionAuthorWireframe';
import VeltCommentDialogSuggestionTimestampWireframe from './VeltCommentDialogSuggestionTimestampWireframe/VeltCommentDialogSuggestionTimestampWireframe';
import VeltCommentDialogSuggestionMenuWireframe from './VeltCommentDialogSuggestionMenuWireframe/VeltCommentDialogSuggestionMenuWireframe';
var VeltCommentDialogSuggestionHeaderWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-header-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogSuggestionHeaderWireframe.Agent = VeltCommentDialogSuggestionAgentWireframe;
VeltCommentDialogSuggestionHeaderWireframe.Author = VeltCommentDialogSuggestionAuthorWireframe;
VeltCommentDialogSuggestionHeaderWireframe.Timestamp = VeltCommentDialogSuggestionTimestampWireframe;
VeltCommentDialogSuggestionHeaderWireframe.Menu = VeltCommentDialogSuggestionMenuWireframe;
export default VeltCommentDialogSuggestionHeaderWireframe;
